import api from 'ApiConfig';

const teacherOtherService = {
  //profile

  updateTeacherPassword: async (oldPassword, newPassword, teacherId) => {
    return api.post('/login/update-password/teacher', {
      oldPassword,
      newPassword,
      teacherId,
    });
  },
  getFeedback: async (entityId) => {
    return api.post('/admin/get-teacher-feedback', {
      entityId,
    });
  },
};

export default teacherOtherService;
